import { ApolloLink, Observable } from 'apollo-link'
import * as printer from 'graphql/language/printer'

interface Payload {
  more: boolean
  result?: { data: {} }
}

const ActionCableLink = options => {
  const { cable, channelName = 'TransportWsChannel', actionName = 'execute' } = options

  return new ApolloLink(operation => {
    const context = operation.getContext()
    const { headers = {} } = context

    return new Observable(observer => {
      const channelId = Math.round(Date.now() + Math.random() * 100000).toString(16)

      // TODO: avoid making connection when there's no such need, since maintaining an active connection is expensive
      const subscription = cable.subscriptions.create(
        {
          channel: channelName,
          channelId,
        },
        {
          // tslint:disable-next-line object-literal-shorthand
          connected: function() {
            const param = {
              type: 'start',
              payload: {
                query: operation.query ? printer.print(operation.query) : null,
                variables: operation.variables,
                operationName: operation.operationName,
              },
            }

            this.perform(actionName, { ...param, header: headers })
          },
          // tslint:disable-next-line object-literal-shorthand
          received: function(payload: Payload) {
            if (payload.result && payload.result.data) {
              observer.next(payload.result)
            }

            if (!payload.more) {
              this.unsubscribe()
              observer.complete()

              // We cannot disconnect here because there might be other active sessions using it
              // cable.disconnect()
              return
            }
          },
        }
      )

      return subscription
    })
  })
}

export default ActionCableLink



// WEBPACK FOOTER //
// ./src/lib/ActionCableLink.ts